const TestimonialsHero = () => {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.85), rgba(37, 99, 235, 0.85)), url('https://readdy.ai/api/search-image?query=modern%20african%20construction%20site%20with%20contemporary%20building%20under%20construction%2C%20african%20workers%20and%20engineers%20collaborating%2C%20tropical%20landscape%20background%2C%20professional%20photography%2C%20bright%20daylight%2C%20successful%20construction%20project%20in%20africa&width=1920&height=400&seq=testimonials-hero-bg-africa&orientation=landscape')`
        }}
      />
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">Témoignages Clients</h1>
        <p className="text-xl md:text-2xl font-light">Découvrez ce que nos clients disent de leur expérience avec ConstructPro</p>
      </div>
    </section>
  );
};

export default TestimonialsHero;
